import {
    log,
} from './frameworkLog';

import * as util from './utils';
import * as features from './features';
import * as core from '../core';
import { polyfillLocation, } from './environment';

import { createStore, } from './store';
import { MutationTypes, } from './store.constants';


let initialized = false;
let initializing = false;

const store = createStore();

//This is a hack to prevent EWN from overwriting our stylesheet.
// eslint-disable-next-line
const ensureStylesheets = function() {
    window.addEventListener('load', () => {
        setTimeout(() => {
            const hasElement = document.querySelectorAll(
                'link[href=\'/one-lni/v1/oneLni.css\']').length > 0;
            const hasAppElement = document.querySelectorAll(
                'link[href=\'main.css\']').length > 0;

            if (!hasElement) {
                util.loadResource('/one-lni/v1/oneLni.css', 'css');
            }
            if (window.location.pathname === '/wagecomplaint/' && !hasAppElement) {
                util.loadResource('/wagecomplaint/main.css', 'css');
            }
        });
    });
};

/**
 * If true, the current platform needs to load the polyfill script before initializing the
 * framework.
 */
export const requiresPolyfill = (() => !window.Promise || !''.startsWith)();

export const isInitialized = function() {
    return initialized;
};

export const isInitializing = function() {
    return initializing;
};

export const initialize = function(callback) {
    if (isInitialized() || isInitializing()) {
        return;
    }

    initializing = true;

    if (requiresPolyfill) {
        util.loadResource(polyfillLocation, 'js', () => {
            initializing = false;
            log.info('Framework Initialized');

            if (util.isFunction(callback)) {
                ensureStylesheets();
                callback();
            }
        });
    } else {
        initializing = false;
        log.info('Framework Initialized');

        if (util.isFunction(callback)) {
            ensureStylesheets();
            callback();
        }
    }
};

/**
 * Creates a new application with the default components and any application specific components
 * that have been registered with addComponent.
 * @param {string} name The name of the application to create.
 * @param {*} applicationConfiguration The Vue js application configuration.
 * @returns {Application} The new application object.
 */
export const createApplication = function(name, applicationConfiguration) {
    applicationConfiguration.store = store;

    applicationConfiguration.router = new core.VueRouter({
        scrollBehavior() {
            window.scrollTo(0, 0);
            return {
                x: 0,
                y: 0,
            };
        },
    });

    applicationConfiguration.router.onReady(() => {
        // The first time we go to any route, after all hooks are resolved
        // This allows us to look and see if we have gone straight to a route
        // by doing F5.  If so, we want to re-route to the default route.
        store.commit(MutationTypes.SetRouterIsInitialized);
    });

    applicationConfiguration.router.beforeEach((to, from, next) => {
        let routerIsInitialized = store.state.formModule.routerIsInitialized;
        if (routerIsInitialized) {
            next();
            return;
        }

        if (to.path !== '/') {
            next('/');
            return;
        }

        next();
    });

    const applicationInstance = new core.Application(name, applicationConfiguration);

    applicationInstance.registerComponents(features.getComponents());

    applicationInstance.registerInteractions(features.getInteractions());

    return applicationInstance;
};


// WEBPACK FOOTER //
// ./source/framework/instance/lifecycle.js